import { VitalsBlock } from 'store/vitals/types';

export const INFANT_VITAL_AGE_MAX = 2;
export const MINOR_VITAL_AGE_MAX = 17;

export const getKeyVital = (age: number, vitals: VitalsBlock[]) => {
  if (age <= INFANT_VITAL_AGE_MAX) {
    return vitals.find(item => item.title.toLowerCase() === 'weight');
  }

  if (age <= MINOR_VITAL_AGE_MAX) {
    return vitals.find(item => item.title.toLowerCase() === 'height');
  }

  return null;
};
